import React from 'react';
import useTitle from '../../useTitle/UseTitle';
import DetailsPage from '../DetailsPage/DetailsPage';
import Card from './Card/Card';
import Carousels from './Carousels';
import MiddleSection from './MiddleSection';

const Home = () => {
    useTitle('Home')
    return (
        <div>
            <Carousels></Carousels>
            <MiddleSection></MiddleSection>
            <DetailsPage></DetailsPage>
            <Card></Card>
        </div>
    );
};

export default Home;